<template>
  <b-card no-body class="committee-card">
    <b-card-header class="committee-header">
      <div class="header-title">
        <i class="fas fa-users-cog mr-2"></i>
        <strong>Comissão de Apuração</strong>
      </div>
      <div class="header-actions">
        <b-button
          v-if="canEdit && (isComplaintAdmin || masterUser)"
          variant="primary"
          size="sm"
          @click="$emit('open-committee')"
          >Editar
        </b-button>
      </div>
    </b-card-header>
    <b-list-group v-if="committee">
      <b-list-group-item
        v-if="committee.admin"
        :variant="getCommitteeUser(committee.admin).active ? '' : 'secondary'"
      >
        {{ getCommitteeUser(committee.admin).name }}
        {{ getCommitteeUser(committee.admin).surname }}
        <span class="badge badge-primary">Relator</span>
        <em v-if="!getCommitteeUser(committee.admin).active" class="float-right"
          >Inativo</em
        >
      </b-list-group-item>
      <template v-if="committee.users">
        <b-list-group-item
          v-for="user in committee.users"
          :key="user._id || user"
          :variant="getCommitteeUser(user).active ? '' : 'secondary'"
        >
          {{ getCommitteeUser(user).name }}
          {{ getCommitteeUser(user).surname }}
          <em v-if="!getCommitteeUser(user).active" class="float-right"
            >Inativo</em
          >
        </b-list-group-item>
      </template>
    </b-list-group>
  </b-card>
</template>

<script>
export default {
  name: "CommitteeCard",
  props: {
    committee: { type: Object, default: null },
    canEdit: { type: Boolean, default: false },
    isComplaintAdmin: { type: Boolean, default: false },
    masterUser: { type: Boolean, default: false },
    getCommitteeUser: { type: Function, required: true },
  },
};
</script>

<style></style>
